<template>
  <div class="select-form-cell">
    <van-field
        v-model="value"
        :name="name + 'Value'"
        :label="label"
        :placeholder="placeholder"
        :label-width="labelWidth || 140"
        @click="onSelect"
        :required="true"
        :rules="[{ required: true, message: '请选择时间' }]"
        readonly
        :clickable="editor"
    >
      <template #right-icon>
        <van-icon name="arrow" v-if="editor" />
      </template>
    </van-field>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择年月"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onConfirm"
          @cancel="showPicker=false"
      />
    </van-popup>
    <van-field v-model="time" :name="name" v-show="false"/>
  </div>
</template>

<script>
export default {
  name: "dateFormCell",
  props: ['label', 'name', 'initValue', 'columns', 'placeholder', 'labelWidth', 'editor'],
  data() {
    return {
      value: this.convertDate(this.initValue),
      time: this.convertDate(this.initValue) + '-01',
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      currentDate: this.initValue,
      showPicker: false
    };
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}`;
      } else if (type === 'month') {
        return `${val}`;
      }
      return val;
    },
    onConfirm(value) {
      console.log('onConfirm => value ', value)
      let year = value.getFullYear();
      let month = value.getMonth()+1
      if (month < 10) {
        month = '0' + month
      }
      this.value = year +'-'+month+'';
      this.time = year +'-'+month + '-01';
      this.showPicker = false
      this.$emit('change', this.time)
    },
    convertDate(value) {
      if (value == null || isNaN(value.getFullYear())) {
        return ''
      }
      let year = value.getFullYear();
      let month = value.getMonth()+1
      if (month < 10) {
        month = '0' + month
      }
      return year +'-'+month+'';
    },
    onSelect(value) {
      if (this.editor === false) {
        return
      }
      this.showPicker = true
      // console.log('onSelect => onSelect ', value)
    }
  },
}
</script>

<style lang="less">
.select-card-cell {
  .van-field__label {
    font-size: 13px;
    font-weight: 400;
    color: #3F403F;
  }
  .van-cell {
    padding: 10px 16px 10px 22px !important;
  }
  .van-cell--required::before {
    left: 14px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/formCell/dateFormCell.vue